import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------recurring invoice page api's-------------------------------->
    /**
     * 
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getRecurrings(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/recinvoice/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getRecurringExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/recinvoice/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postRecurringInvoiceUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/update/' + id, form)
    },
    /**
     * create api 
     * @param {*} form 
     */
    postRecurringInvoice(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getRecurringInvoice(id,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/recinvoice/view/' + id+"?type="+type)
    },
    getRecurringInvoiceView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/recinvoice/viewpage/' + id)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreateRecurringInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateRecurringInvoice(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteRecurringInvoice(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/filterdelete', data)
    },
    /**
     * bulk delete api 
     */
    postRecurringInvoiceBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/bulkdelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getRecurringInvoiceDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getRecurringInvoiceStop(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/stoprecurring', data)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getInvoiceRecurring(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/invoice/recurringview/' + id)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getRecuringInvoice(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/recinvoice/converttoinvoice/' + id)
    },
    bulkStopRecurring(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/recinvoice/bulkstoprecurring', data)
    },

}